import React from 'react';

const Footer = () => (
  <footer className="app-footer">
    <span className="d-inline-block">NETPG Apoio Administrativo &copy; 2021</span>
  </footer>
);
export default Footer;
